import CustomError from '../service/CustomerErrorHandler'
import { parseLinkHeader } from '@web3-storage/parse-link-header'
import { ERRORS } from './constants'

export const loadJSON = async (configOrURL, server) => {
  const config = configOrURL.url ? configOrURL : { url: configOrURL, method: 'GET' }
  config.method = config.method || 'GET'

  const isPost = config.method === 'POST'
  const contentType = isPost ? 'application/x-www-form-urlencoded; charset=UTF-8' : 'application/json'

  const headers = new Headers({
    Accept: 'application/json',
    Authorization: `Bearer ${config.token}`,
    'Content-Type': contentType
  })

  const body = isPost ? new URLSearchParams(config.body).toString() : null

  const requestConfig = { method: config.method, headers, cache: 'default', body }

  const loadedResponse = []
  const resultWithHeader = { id: config.id }
  
  // If the URL is relative add on the server, otherwise use as is.
  // When paging through results the URL will be absolute.
  let nextUrl = URL.parse(config.url, server).toString()

  do {
    const response = await fetch(nextUrl, requestConfig).then(handleErrors)
    const json = await response.json()
    const links = parseLinkHeader(response.headers.get('Link'))
    nextUrl = links?.next?.url || null

    if(config.method !== 'GET') {
      loadedResponse.push(json)
    } else {
      loadedResponse.push(...json)
    }

    // set response to load json
    resultWithHeader.data = loadedResponse

    if(config.noLoop) {
      resultWithHeader.links = links
      break
    }
  } while(nextUrl)

  return resultWithHeader
}





/**
 * Handle generic errors when performing a fetch.
 *
 * @param response The response to the fetch.
 * @returns {{ok}|*|Promise<T>}
 */
export const handleErrors = (response) => {
  if (!response.ok) {
    if (response.status === 400) {
      throw new CustomError(ERRORS.BAD_REQUEST, "Problem fetching API", response.status);
    }
    if (response.status === 403) {
      // This will happen the first time someone uses the tool.
      throw new CustomError(ERRORS.LOGIN, 'Proxy doesn\'t have token for user', response.status)
    } else if (response.status === 401) {
      const authHeader = response.headers.get('WWW-Authenticate')
      if (authHeader && !authHeader.includes('proxy')) {
        // This will typically happen when someone has deleted their token
        throw new CustomError(ERRORS.LOGIN,'Your token isn\'t valid any more', response.status)
      }
      // TODO We should have better parsing of the header
      if (authHeader?.includes('invalid_token')) {
        throw new Error('Your session has expired, please try relaunching the tool')
      }
      // If there's no auth header look in the JSON
      return response.json().then(error => {
        if (error.status === 'unauthorized') {
          // Attempting an operation for something they don't have access to.
          throw new CustomError(ERRORS.UNAUTHORIZED, error.status)
        } else {
          // This is probably because you need to renew you're token because the scopes have changed.
          throw new CustomError(ERRORS.LOGIN, 'Token isn\'t valid for this operation.')
        }
      })
    }
  }
  return response
}